// Gates both halves of the temporary star notice — `StarNoticeBannerComponent`
// and the notice modal behind `StarNoticeModalGuard`. They are one announcement,
// so they are switched on, and later retired, together.
export const STAR_NOTICE_BANNER_UNLEASH_KEY = 'rd_star_notice_banner';
